// @flow

export const CONTACT_FORM_INITIATING = 'CONTACT_FORM_INITIATING'
